import { useState, useEffect } from 'react';
import Sidebar from '@/UIlibrary/Sidebar/Sidebar';
import { useTranslations } from 'use-intl';
import { GRAY_COLORS } from '@/stories/Library/Components/globalTheme';
import { UserPlus } from 'react-feather';
// import { UserPlus, Book, Grid, DollarSign } from 'react-feather';
import { Outlet, useLocation } from 'react-router-dom';

export default function Root() {
	const t = useTranslations('Layout');
	const [currentPath, setCurrentPath] = useState('');
	const location = useLocation();

	useEffect(() => {
		setCurrentPath(location.pathname + location.search);
	}, [location.pathname, location.search]);

	const getLayoutStyles = () => ({
		display: 'flex',
		height: '100vh',
		overflowX: 'hidden' as const
	});

	const getMainContentStyles = () => ({
		flexGrow: 1,
		overflowY: 'auto' as const,
		height: '100vh',
		overflowX: 'auto' as const,
		backgroundColor: GRAY_COLORS.gray25,
		minWidth: 0
	});

	const getSectionGroups = {
		sections: [
			// {
			// 	name: t('Dashboard'),
			// 	icon: <Grid size={16} />,
			// 	items: [
			// 		{
			// 			name: t('MyDashboard'),
			// 			link: 'dashboard?startingTab=dashboard'
			// 		},
			// 		{
			// 			name: t('CompanyDashboard'),
			// 			link: 'dashboard?startingTab=companyDashboard'
			// 		}
			// 	],
			// 	hasDropdown: true
			// },
			{
				name: t('ClientManagement'),
				icon: <UserPlus size={16} />,
				items: [
					{
						name: t('Clients'),
						link: 'clients'
					}
				],
				hasDropdown: true
			}
			// {
			// 	name: t('CreditManagement'),
			// 	icon: <Book size={16} />,
			// 	items: [
			// 		{
			// 			name: t('TotalLoan'),
			// 			link: '/total-loans'
			// 		},
			// 		{
			// 			name: t('TotalCredits'),
			// 			link: '/total-credits'
			// 		},
			// 		{
			// 			name: t('NewCredits'),
			// 			link: '/new-credits'
			// 		},
			// 		{
			// 			name: t('StandingLoans'),
			// 			link: '/standing-loans'
			// 		},
			// 		{
			// 			name: t('DelinquentLoans'),
			// 			link: '/delinquent-loans'
			// 		}
			// 	],
			// 	hasDropdown: true
			// },
			// {
			// 	name: t('Transactions'),
			// 	icon: <DollarSign size={16} />,
			// 	items: [
			// 		{
			// 			name: t('TotalPayments'),
			// 			link: '/tpv-loans'
			// 		},
			// 		{
			// 			name: t('TPV'),
			// 			link: '/tpv-debit'
			// 		},
			// 		{
			// 			name: t('TransactionHistory'),
			// 			link: '/transaction-history'
			// 		},
			// 		{
			// 			name: t('PaymentSuccessRate'),
			// 			link: '/payment-success-rate'
			// 		}
			// 	],
			// 	hasDropdown: true
			// }
		]
	};

	return (
		<div style={getLayoutStyles()} id="portal-layout">
			<div>
				<Sidebar
					user={{
						firstName: 'John',
						initials: 'JD'
					}}
					companyLogoURL={'/logo.svg'}
					sectionGroups={getSectionGroups}
					settingsTitle={t('Settings')}
					logoutTitle={t('Logout')}
					supportTitle={t('Support')}
					currentPath={currentPath}
				/>
			</div>
			<main style={getMainContentStyles()} className="custom-scrollbar">
				<Outlet />
			</main>
		</div>
	);
}
